<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style>

    .osfQuizShowProductsPage {
        font-family: Roboto;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        min-height: 25rem;
    }

    .osfQuizShowProductsPage h2, .osfQuzizEndPage p {
        font-family: Roboto-Medium;
    }

    .osfQuizShowProductsPage h2 {
        font-size: 1.5rem;
        color: #333333;
        text-align: center;
    }

    .osfQuizShowProductsPage p {
        font-size: 0.875rem;
    }
</style>

<template>
    <div
        class="osfQuizShowProductsPage"
        v-html="showProductsJSON"
    />
</template>

<script>
export default {
    name: 'ShowProducts',
    computed: {
        showProductsJSON: function () {
            return this.$store.state.showProductsJSON;
        }
    }
};
</script>
